import { IsString, IsNumber } from 'class-validator';

export class FloorPlanCreateDto {
  @IsString()
  readonly svgData: string;

  @IsString()
  readonly jsonData: string;

  @IsNumber()
  readonly roomId: number;
}
